export default [
  {
    name: "English",
    code: "en",
  },
  {
    name: "French",
    code: "fr",
  },
] as const;
